import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/agriculture.jpg";
import Card1 from "../Images/CIRCODU-BANNERS-5.jpg";
import "../Pages/OurHistory.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function AgriculturalManagement() {
  return (
    <div className="ne-page">
      <SEO
        title="Agricultural Management: Cultivating Sustainable Farming for Uganda's Future"
        description="CIRCODU's agricultural thematic area promotes sustainable farming practices, enhances food security, and strengthens land management in Uganda to improve livelihoods and protect the environment for future generations."
        keywords="agricultural development, sustainable agriculture, clean energy, CIRCODU, thematic area, rural livelihoods, environmental outcomes, agricultural research, sustainable farming practices, clean energy solutions for agriculture, CIRCODU agricultural initiatives, agricultural thematic area Uganda, sustainable agriculture Uganda, clean energy agriculture Uganda, rural development Uganda, environmental sustainability agriculture Uganda"
        url="/our-thematic-areas/agricultural-management"
        image={Card1}
        type="website"
      />

      {/* Hero */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Agricultural Management</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Our Thematic Areas
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Agricultural Management
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="section border-bottom">
        <div className="container border-top">
          <div className="row">
            <div className="col-md-12 mt-2">
              {/* Intro */}
              <h5 style={{ color: "#008250", fontSize: "16px" }}>
                <b>Agricultural Management</b>
              </h5>
              <p className="texty">
                Agriculture is the heartbeat of Uganda's economy. It feeds
                families, drives livelihoods, and holds the key to ending
                poverty for millions. Yet the way we farm today will determine
                whether the land can sustain us tomorrow. CIRCODU is committed
                to ensuring that it can.
              </p>
              <p className="texty">
                By promoting sustainable agricultural practices and responsible
                land management, we work toward the achievement of{" "}
                <b>Sustainable Development Goal 2,</b> ending hunger, achieving
                food security, improving nutrition, and building agricultural
                systems that are resilient, productive, and kind to the earth.
              </p>

              {/* Our Overall Objective */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>🎯 Our Overall Objective</b>
              </h5>
              <p className="texty">
                To promote sustainable agricultural management practices across
                Uganda that{" "}
                <b>
                  improve productivity, enhance food and nutrition security,
                  protect natural resources, and reduce the environmental
                  footprint of farming
                </b>{" "}
                for the benefit of communities today and generations yet to
                come.
              </p>

              {/* Specific Objectives */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>🔑 Specific Objectives</b>
              </h5>
              <ol className="texty mt-2">
                <li className="mt-2">
                  <b>Promote Sustainable Farming Practices:</b> We support the
                  adoption of{" "}
                  <b>
                    conservation agriculture, agroforestry, integrated pest
                    management, and climate-smart techniques
                  </b>{" "}
                  that boost productivity without degrading the land because
                  feeding Uganda today must not come at the cost of feeding
                  Uganda tomorrow.
                </li>
                <li className="mt-2">
                  <b>Enhance Food and Nutrition Security:</b> Working directly
                  with farming communities, we promote{" "}
                  <b>sustainable and resilient agricultural systems</b> that
                  improve access to diverse, nutritious food systems strong
                  enough to withstand climate variability, market shocks, and
                  the growing pressures of a changing world.
                </li>
                <li className="mt-2">
                  <b>Strengthen Sustainable Land and Water Management:</b> Land
                  and water are Uganda's most precious agricultural assets.
                  CIRCODU promotes responsible{" "}
                  <b>
                    land-use planning, soil conservation, and watershed
                    management
                  </b>{" "}
                  to prevent degradation, protect natural resources, and ensure
                  the long-term viability of agricultural land across the
                  country.
                </li>
                <li className="mt-2">
                  <b>
                    Build Capacity of Farmers and Agricultural Stakeholders:
                  </b>{" "}
                  The most powerful driver of sustainable agriculture is a
                  knowledgeable farmer. We equip{" "}
                  <b>
                    smallholder farmers, farmer cooperatives, and agricultural
                    extension workers
                  </b>{" "}
                  with the knowledge, skills, and tools to implement sustainable
                  practices and improve their livelihoods from the field to the
                  market.
                </li>
              </ol>
            </div>
            <div className="col-md-8">
              {/* Our Actions on the Ground */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>⚙️ Our Actions on the Ground</b>
              </h5>
              <ol className="texty mt-2">
                <li className="mt-2">
                  🌾 <b>Farmer Training and Extension Services:</b> CIRCODU
                  designs and delivers targeted training programs that build the
                  capacity of smallholder farmers to adopt{" "}
                  <b>sustainable and climate-smart practices,</b> improving
                  yields, reducing environmental impact, and strengthening food
                  security from the ground up.
                </li>
                <li className="mt-2">
                  🌳 <b>Agroforestry and Soil Health Promotion:</b> We champion
                  agroforestry systems and soil conservation techniques,
                  including <b>composting, cover cropping, and terracing</b>{" "}
                  that restore soil health, prevent erosion, and create more
                  productive and resilient farming landscapes for Uganda's
                  agricultural communities.
                </li>
                <li className="mt-2">
                  🗂️ <b>Support for Market Linkages:</b> Sustainable farming
                  must also be economically viable. CIRCODU facilitates access
                  to <b>markets, agricultural inputs, and financial services</b>{" "}
                  for smallholder farmers, strengthening their participation in
                  agricultural value chains and ensuring that their hard work
                  translates into genuine income and opportunity.
                </li>
                <li className="mt-2">
                  🌿 <b>Advocacy for Sustainable Agricultural Policies:</b>{" "}
                  Lasting transformation requires the right policy environment.
                  We engage with{" "}
                  <b>
                    government agencies, research institutions, and development
                    partners
                  </b>{" "}
                  to champion policies and investments that support sustainable
                  agriculture, food security, and rural development across
                  Uganda because the right rules make all the difference.
                </li>
              </ol>
            </div>
            <div
              className="col-md-4 mb-1"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="imagecard" style={{ width: "100%" }}>
                <img
                  src={Card1}
                  alt="CIRCODU Agricultural Management Programs"
                  width="100%"
                  style={{ borderRadius: "5%", objectFit: "cover" }}
                />
              </div>
            </div>

            <hr />

            {/* Closing statement */}
            <div className="col-md-12">
              <p className="texty">
                <i>
                  Every seed planted sustainably is an investment in Uganda's
                  future. At CIRCODU, we are here to make sure that the future
                  grows strong.
                </i>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AgriculturalManagement;
